import {Divider, Skeleton} from 'native-base';
import React, {useMemo} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Box} from '../../../../components/core/view';
import BuyerInfo from '../BuyerInfo/BuyerInfo';
import {Buyers} from '../../../types/itemDetails';
import {H6Text} from '@buncha/components/core/text';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';
import {useSubstituteItemDetailsContext} from '@buncha/itemDetails/hooks/SubstituteItemDetail';

interface SubsBuyerDetailsProps {
  isMenu: boolean;
  isCustomItem: boolean;
  loadingBuyer?: boolean;
}

const SubsBuyerDetails = (props: SubsBuyerDetailsProps) => {
  const {isMenu, isCustomItem, loadingBuyer} = props;
  const {state, dispatch} = useSubstituteItemDetailsContext();
  const {constants} = state;
  const isEnabled = constants?.CHAT_ENABLE === 'true';
  const muliFont = useFontTheme('muli');
  const theme = useColorThemeType();
  const {body} =
    useGetLocale(Modules.itemDetails, ShopperScreens.ItemDetails) ?? {};

  const renderBuyers = useMemo(() => {
    if (loadingBuyer)
      return (
        <Box style={styles.skeleton}>
          <Skeleton.Text px="4" />
          <Skeleton px="4" my="4" rounded="md" startColor="primary.100" />
        </Box>
      );
    return state?.buyersForItem?.map((buyer: Buyers) => {
      return (
        <BuyerInfo
          key={buyer.id}
          buyers={buyer}
          isMenu={isMenu}
          isCustomItem={isCustomItem}
          chatEnable={isEnabled}
          dispatch={dispatch}
          item={state?.item}
          isOosSubstitute={true}
        />
      );
    });
  }, [
    isEnabled,
    dispatch,
    isCustomItem,
    isMenu,
    state?.buyersForItem,
    loadingBuyer,
    state?.item,
  ]);

  return (
    <Box style={[styles.container]}>
      <Divider
        style={[
          styles.divider,
          {
            backgroundColor: theme?.background?.gray?.[200],
          },
        ]}
      />
      <If condition={state?.buyersForItem?.length}>
        <H6Text
          style={[
            styles.textStyle,
            {
              fontFamily: muliFont[600].normal,
              color: theme?.text.blue[300],
            },
          ]}>
          {body?.totalCustomersPurchased}
          {state?.buyersForItem?.length}
        </H6Text>
      </If>
      {renderBuyers}
    </Box>
  );
};

export default React.memo(SubsBuyerDetails);
